import { useQuery } from "@tanstack/react-query"

import {
  type AuditStatsResponse,
  type AuditTrailFilters,
  type AuditTrailResponse,
  getAuditStats,
  getAuditTrail,
} from "@/api/admin-api"

import { adminQueryKeys } from "../admin-query-keys"
import { FAST_STALE_TIME, GC_TIME, MEDIUM_STALE_TIME } from "./_shared"

// Audit Trail Hooks
export function useAuditTrailQuery(filters: AuditTrailFilters = {}, enabled = true) {
  return useQuery<AuditTrailResponse>({
    queryKey: adminQueryKeys.auditTrail(filters),
    queryFn: () => getAuditTrail(filters),
    enabled,
    staleTime: FAST_STALE_TIME,
    gcTime: GC_TIME,
  })
}

export function useAuditStatsQuery(startDate?: string, endDate?: string, enabled = true) {
  return useQuery<AuditStatsResponse>({
    queryKey: adminQueryKeys.auditStats(startDate, endDate),
    queryFn: () => getAuditStats(startDate, endDate),
    enabled,
    staleTime: MEDIUM_STALE_TIME,
    gcTime: GC_TIME,
  })
}
